import { ReactElement, useMemo } from 'react';
import { HubShell } from '@/components/Hub/HubShell';
import { TabOption } from '@/components/Timeline/TimelineTabs';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { WonTab } from '../intake/tabs/WonTab';
import { EmployerTab } from './tabs/EmployerTab';
import { InsuranceTab } from './tabs/InsuranceTab';

export type CoverageTab = 'employer' | 'insurance' | 'won';
const DEFAULT_TAB: CoverageTab = 'employer';

const TAB_OPTIONS: TabOption<CoverageTab>[] = [
  { label: 'Employer', icon: null, value: 'employer' },
  { label: 'Insurance', icon: null, value: 'insurance' },
  { label: 'Won', icon: null, value: 'won' },
];

/** Care ops' Coverage pill (BAR-3093): Employer, Insurance and Won (BAR-3097–3099). */
export function CoverageHub(): ReactElement {
  const { canViewPayments } = useCurrentUser().currentUserPermissions;
  // Won reads the payments ledger, so it's hidden without payments access, as on Intake.
  const tabs = useMemo(
    () => (canViewPayments ? TAB_OPTIONS : TAB_OPTIONS.filter((tab) => tab.value !== 'won')),
    [canViewPayments]
  );

  return (
    <HubShell tabs={tabs} defaultTab={DEFAULT_TAB}>
      {(activeTab) => (
        <>
          {activeTab === 'employer' && <EmployerTab />}
          {activeTab === 'insurance' && <InsuranceTab />}
          {activeTab === 'won' && <WonTab variant="coverage" />}
        </>
      )}
    </HubShell>
  );
}
